module.exports = __webpack_public_path__ + "img/pit-run.86a7baf8.png";